/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventDtoPage } from '../../models/event-dto-page';

export interface ListEvents$Params {
  roomId: string;
  type: string;
  offset?: number;
  limit?: number;
}

export function listEvents(http: HttpClient, rootUrl: string, params: ListEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<EventDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEvents.PATH, 'get');
  if (params) {
    rb.path('roomId', params.roomId, {"style":"simple"});
    rb.query('type', params.type, {"style":"form"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventDtoPage>;
    })
  );
}

listEvents.PATH = '/chat/v0/rooms/{roomId}/events';
